import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl, ValidationErrors } from '@angular/forms';
import { Archive } from '../../../class/archive';
import { ArchiveService } from '../../../service/archive/archive.service';
import { TranslateService } from '@ngx-translate/core';
import { Message, SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { MapsAPILoader } from '@agm/core';
import { Marker } from '../../../../../interfaces/marker';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';
import { HasPermissionService } from '../../../service/has-permission/has-permission.service';
import { calendarES } from '../../../../../theme/functions/calendarES';

@Component({
  selector: 'app-new-archive',
  templateUrl: './new-archive.component.html',
  styleUrls: ['./new-archive.component.scss']
})
export class NewArchiveComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() edit: Archive;

    messages: Message[] = [];

    public promiseForm: Promise<any>;
    public form: FormGroup;

    public company_id: AbstractControl ;
    public candidate_id: AbstractControl ;
    public income_date: AbstractControl ;
    public arl_date: AbstractControl ;
    public eps_date: AbstractControl ;
    public ccf_date: AbstractControl ;
    public scan_date: AbstractControl ;
    // public retirement_date: AbstractControl ;
    public es: any;

    public modViewDialog: boolean;

    public save_exit: boolean;

    constructor(
        fb: FormBuilder,
        public archiveService: ArchiveService,
        public translate: TranslateService,
        private notificationsService: NotificationsService) {
        this.modViewDialog = false;

        this.save_exit = false;

        this.es = calendarES();
        
        this.form = fb.group({
            'company_id': ['', Validators.compose([Validators.required])],
            'candidate_id': ['', Validators.compose([Validators.required])],
            'income_date': [''],
            'arl_date': [''],
            'eps_date': [''],
            'ccf_date': [''],
            'scan_date': [''],           
        });

        this.company_id = this.form.controls['company_id'];
        this.candidate_id = this.form.controls['candidate_id'];
        this.income_date = this.form.controls['income_date'];
        this.arl_date = this.form.controls['arl_date'];
        this.eps_date = this.form.controls['eps_date'];
        this.ccf_date = this.form.controls['ccf_date'];
        this.scan_date = this.form.controls['scan_date'];
        // this.retirement_date = this.form.controls['retirement_date'];
    }

    ngOnInit() {
        if (this.edit) {
            this.company_id.setValue(this.edit.company_id);
            this.candidate_id.setValue(this.edit.candidate_id);
            if (this.edit.income_date) {
                this.income_date.setValue(new Date(this.edit.income_date));
            }
            if (this.edit.arl_date) {
                this.arl_date.setValue(new Date(this.edit.arl_date));
            }
            if (this.edit.eps_date) {
                this.eps_date.setValue(new Date(this.edit.eps_date));
            }
            if (this.edit.ccf_date) {
                this.ccf_date.setValue(new Date(this.edit.ccf_date));
            }
            if (this.edit.scan_date) {
                this.scan_date.setValue(new Date(this.edit.scan_date));
            }
            // if (this.edit.retirement_date) {
            //     this.retirement_date.setValue(new Date(this.edit.retirement_date));
            // }
        } else {
            // this.activated.setValue(true);
        }
    }

    public cancelArchive () {
        console.log('reset');
        this.form.reset();
        this.close.emit(true);
    }

    public saveandexit (values){
        this.save_exit = true;
        this.newArchive(values);
    }

    public newArchive(values) {
        const param = {
            'company_id': values.company_id.id,
            'candidate_id': values.candidate_id.id,
            'income_date': values.income_date,
            'arl_date': values.arl_date,
            'eps_date': values.eps_date,
            'ccf_date': values.ccf_date,
            'scan_date': values.scan_date,
        };
        if (values && this.form.valid) {
            const promise = (this.edit) ?
                this.archiveService.updateArchive(this.edit.id, param)
                :
                this.archiveService.newArchive(param);

            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.notificationsService.growlNotify('success', res);
                        // this.msg.emit( { severity: 'success', summary: res  } );
                        if (this.save_exit) {
                            this.close.emit(true);
                            this.form.reset();
                            this.save_exit = false;
                        }
                    });
                },
                error => {
                    let msg = '';
                    this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                        this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                            JSON.parse(error._body).errors.forEach(element => {
                                if (element.source) {
                                    if (element.source.pointer) {
                                        this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                            msg = msg + res3 + ', ';
                                        });
                                    }
                                }
                            });
                            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                            // this.msg.emit( { severity: 'error', summary: 'Error' } );
                        });
                    });
                }
            );
        }
    }

    public showNewCandidateDialog() {
        this.modViewDialog = true;
    }

    public showResultNewCandidate(msg) {
        this.messages = [];
        this.messages.push(msg);
    }

    public cancelNewCandidate() {
        this.modViewDialog = false;
    }

    // public formatDate(date) {
    //     const d = new Date(date);
    //     let month = '' + (d.getMonth() + 1);
    //     let day = '' + d.getDate();
    //     const year = d.getFullYear();
    //     let hours = '' + d.getHours();
    //     let minutes = '' + d.getMinutes();
    //     let seconds = '' + d.getSeconds();

    //     if (month.length < 2) {
    //         month = '0' + month;
    //     }
    //     if (day.length < 2) {
    //         day = '0' + day;
    //     }

    //     if (hours.length < 2) {
    //         hours = '0' + hours;
    //     }

    //     if (minutes.length < 2) {
    //         minutes = '0' + minutes;
    //     }

    //     if (seconds.length < 2) {
    //         seconds = '0' + seconds;
    //     }

    //     return [year, month, day].join('-');
    // }

    getFormValidationErrors(form) {
        let value = '';
        Object.keys(form.controls).forEach(key => {
            const controlErrors: ValidationErrors = form.get(key).errors;
            if (controlErrors != null) {
                Object.keys(controlErrors).forEach(keyError => {
                    value = 'Key control: ' + key + ', keyError: ' + keyError + ', err value: ' + controlErrors[keyError];
                });
            }
        });
        return (value);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/archives/new-archive/new-archive.component.ts